<template>
  <div class="box13">
    <div class="left-box">
      AI智能应用开发（Java）<br/>学习路线图
      <div class="left-btn" @click="goHref">免费领取</div>
    </div>

    <img
      class="box14-icon"
      src="../../../assets/coursePage/java/box14/icon.png"
      alt
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    goHref() {
        this.mai("JavaEE-就业课","免费领取",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box13 {
  position: relative;
  width: 100%;
  height: 260px;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/java/box14/bgc.png") no-repeat;
  background-size: cover;
  .left-box {
    position: absolute;
    top: 32px;
    left: 32px;
    font-size: 40px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    .left-btn {
      margin-top: 24px;
      width: 160px;
      height: 56px;
      background: #ffffff;
      border-radius: 8px;
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #165dff;
      line-height: 56px;
    }
  }

  .box14-icon {
    position: absolute;
    right: 28px;
    bottom: -30px;
    width: 300px;
    height: 272px;
  }
}
</style>
